import styled from 'styled-components'
import { colors, input } from 'styles'

export const StyledErrorTextArea = styled.div`
  .errorMsg {
    display: inline-block;
    text-align: center;
    color: tomato;
  }
`

const StyledTextArea = styled.textarea`
  max-width: 100%;
  ${input.common};
  resize: vertical;
  background-color: transparent;

  &:focus {
    outline: none;
  }

  &.error {
    border-color: tomato;
  }

  &::placeholder {
    color: ${colors.textMain};
    font-weight: 600;
  }
`

export default StyledTextArea
